import {
  SubjectivitySearchResponse,
  SubjectivitySearchRequestQuery,
  SubjectivityUpdateRequestBody,
} from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type SubjectivityItem = ArrayItem<SubjectivitySearchResponse['items']>;

export const getSubjectivitiesQuery = ({
  quoteId,
  policyId,
  sort,
  quoteType,
  pageOffset,
  pageLimit,
}: SubjectivitySearchRequestQuery & Partial<SubjectivityUpdateRequestBody>) => {
  const query = new URLSearchParams();
  if (pageLimit !== undefined) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset !== undefined) {
    query.append('pageOffset', String(pageOffset));
  }
  if (sort) {
    query.append('sort', sort.toString());
  }
  if (quoteId) {
    query.append('quoteId', quoteId);
  }
  if (policyId) {
    query.append('policyId', policyId);
  }
  if (quoteType) {
    query.append('quoteType', quoteType);
  }
  return query.toString();
};
